module.exports = __webpack_public_path__ + "static/heimberatung-d85c8c194818aa88eb6b18edb8dd3421.jpg";